import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {TState} from '../redux/store.type';
import {isImagePathSupported} from '../pages/branding/whatsAppScreen/whatsAppValidation';

export const useDefaultFbImage = (isWhatsApp?: boolean) => {
    // settings is null until an event is loaded — the sending popup also runs at package level
    const design = useSelector((s: TState) => s.event.settings?.design);

    const getDefaultImage = useCallback(() => {
        const mobileImage = {
            path: design?.fbImgMobile,
            imageId: design?.fbImgMobileId,
            credit: design?.credit?.mobile
        };
        const postImage = {
            path: design?.fbImgPost,
            imageId: design?.fbImgPostId,
            credit: design?.credit?.post
        };
        const fbImage = {
            path: design?.fbImg,
            imageId: design?.fbImgId
        };
        const defaultImage = {path: '', imageId: ''};  
        if(isWhatsApp) {
            const mobileImageSupported = mobileImage.path && isImagePathSupported(mobileImage.path);
            const postImageSupported = postImage.path && isImagePathSupported(postImage.path);
            const fbImageSupported = fbImage.path && isImagePathSupported(fbImage.path);
            return mobileImageSupported ? mobileImage: postImageSupported ? postImage: fbImageSupported ? fbImage: defaultImage;
        }

        return mobileImage.path ? mobileImage : postImage.path ? postImage : design?.fbImg ? fbImage : defaultImage;
    }, [design, isWhatsApp]);

    return getDefaultImage();
};

